import React, { useState } from "react";
import styled from "styled-components";
import { H2Desk, P1Desk, P2Desk, P3Desk } from "../../styles/styles_text";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import { Icon } from "../../components/Menu/styles";
import AddNoteIcon from "../../assets/icons/add_notes.svg";
import { FilterButton } from "../../styles/styles_input_pesquisas";
import NewFilter from "../../assets/kinologyIcons/svg/new_filter.svg";
import Close from "../../assets/kinologyIcons/svg/close.svg";
import { Textarea } from "../../components/ui/textarea";
import { Button } from "../../components/ui/button";

const AddNote: React.FC = () => {
	const [nota, setNota] = useState("");

	const handleSave = () => {
		console.log(nota); // Função para imprimir o valor do input no console
		// Aqui você pode adicionar lógica adicional para salvar a anotação, se necessário
	};

	return (
		<AlertDialog>
			<AlertDialogTrigger style={{ width: "100%" }}>
				<TempoEstimado
					onClick={() => {
						return false;
					}}
				>
					<Icon src={AddNoteIcon} /> Criar anotação
				</TempoEstimado>
			</AlertDialogTrigger>
			<AlertDialogContent
				className="w-[100%] flex flex-col items-center justify-center p-10"
				style={{ width: "50rem", backgroundColor: "#F1F2F3" }}
			>
				<AlertDialogCancel
					style={{ position: "absolute", top: "1rem", right: "1rem", border: 'none', boxShadow: 'none' }}
				>
					<FilterButton
						onClick={() => {
							return false;
						}}
						src={Close}
					/>
				</AlertDialogCancel>

				<Title>Adicionar anotação</Title>

				<div style={{ width: "100%", fontSize: "0.7rem" }}>
					<Title>Anotação</Title>
				</div>
				<div className="grid w-full gap-2">
					<Textarea 
						placeholder="Digite aqui" 
						style={{backgroundColor: 'white', height: '13.68rem', color: '#3D4259'}} 
						maxLength={2000} 
						value={nota}
						onChange={(e) => setNota(e.target.value)}
		
					/>
					<text style={{textAlign: 'end', color: '#797D8D'}}>{nota.length}/2000</text>
					<AlertDialogAction
						style={{
							marginTop: "5rem",
							backgroundColor: "#000E4B",
							color: "#FAFAFA",
						}}
						onClick={handleSave} 
					>
						Salvar
					</AlertDialogAction>
				</div>
			</AlertDialogContent>
		</AlertDialog>
	);
};

const TempoEstimado = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	font-family: "NotoSans-Regular";
	font-size: 0.9rem;
	font-weight: 500;
	line-height: 28.8px;
	width: 100%;
	color: #00a377;
	align-items: center;
	padding: 0.1rem;
	border-radius: 0.8rem;
	border: 2px solid var(--Neutras-Grey-K-10, #dedfe3);
`;

const Title = styled.h1`
	color: var(--Primrias-Blue-K-Principal, #000e4b);
	font-family: "NotoSans-Regular";
	font-size: 1.2em;
	font-style: normal;
	font-weight: 700;
	line-height: 104%; /* 29.12px */
`;
export default AddNote;
